import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AppContainer from '~/components/AppContainer';

function Chat() {
  const location = useLocation();
  const navigate = useNavigate();
  const { room } = location.state || {};

  useEffect(() => {
    if (room) {
      // Czyści stan w historii przeglądarki bez przeładowania/nawigacji
      window.history.replaceState({}, document.title);
    } else {
      navigate('/');
    }
  }, [room, navigate]);

  return (
    <div data-page="Chat" className="chat">
      <AppContainer />
    </div>
  );
};

export default Chat;
